export const PAYMENT_OPTION_FP = "FP";
export const PAYMENT_OPTION_SHOPEE = "Shopee";
export const PAYMENT_OPTION_GRAB = "Grab";
export const PAYMENT_OPTION_RAZER = "Razer";
export const PAYMENT_OPTION_PAYEX = "Payex";
export const PAYMENT_OPTION_SHOPBACK = "Shopback";
export const PAYMENT_OPTION_EPP = "EPP";
export const PAYMENT_OPTION_EPP_3_6_12_MONTHS = "EPP3612";
export const PAYMENT_OPTION_EPP_6_12_MONTHS = "EPP612";
export const PAYMENT_OPTION_ATOME = "Atome";
export const PAYMENT_OPTION_BNPL = "BNPL";

export const PAYMENT_OPTION_VISA = "credit";
export const PAYMENT_OPTION_FPX = "fpx";
export const PAYMENT_OPTION_FPX_ENTERPRISE = "fpxEnterprise"
export const PAYMENT_OPTION_EWALLET = "EWALLET";

export const PAYMENT_FULL_PRICE = [
	{
		name: "Visa / Mastercard",
		value: "credit",
	},
	{
		name: "Online Banking (FPX",
		value: "fpx",
	},
	{
		name: "e-Wallet",
		value: "e-walet",
	},
];

export const PAYMENT_EWALLET_TYPE = [
	{
		name: "Touch 'nGo eWallet",
		value: "TNG-EWALLET",
		img: "/assets/icons/payments/e-wallet/tngo-logo.png",
	},
	{
		name: "DuitNow QR",
		value: "RPP_DuitNowQR",
		img: "/assets/icons/payments/e-wallet/duitnow-logo.png",
	},
	{
		name: "Grabpay",
		value: "GrabPay",
		img: "/assets/icons/payments/e-wallet/grabpay-logo.png",
	},
	// https://policystreet.atlassian.net/browse/A2C-392
	// {
	// 	name: "Shopee Pay",
	// 	value: "ShopeePay",
	// 	img: "/assets/icons/payments/e-wallet/shopeepay-logo.png",
	// },
	{
		name: "Boost",
		value: "BOOST",
		img: "/assets/icons/payments/e-wallet/boost-logo.png",
	},
	{
		name: "MAE by Maybank2u",
		value: "MB2U_QRPay-Push",
		img: "/assets/icons/payments/e-wallet/mae-logo.png",
	},
	{
		name: "Alipay+",
        value: "AlipayPlus",
		img: "/assets/icons/payments/e-wallet/alipay-logo.png",
	},
];

export const PAYMENT_EPP_TYPE = [
	{
		name: "AmBank (M) Berhad",
		value: "creditU",
		img: "/assets/icons/payments/banks/ambank-logo.png",
	},
	{
		name: "Hong Leong Bank Berhad",
		value: "creditAE",
		img: "/assets/icons/payments/banks/hongleong-logo.png",
	},
	{
		name: "Affin Bank Berhad",
		value: "crediAB",
		img: "/assets/icons/payments/banks/affin-logo.png",
	},
	{
		name: "RHB Bank Berhad",
		value: "creditAH",
		img: "/assets/icons/payments/banks/rhb-logo.png",
	},
	{
		name: "CIMB Bank Berhad",
		value: "creditL",
		img: "/assets/icons/payments/banks/cimb-logo.png",
	},
];

export const PAYMENT_FPX_ENTERPRISE_TYPE = [
    {
        name: "Affin Bank",
        value: 'FPX_B2B_ABB',
        img: ''
    },
    {
        name: "Affin Max",
        value: 'FPX_B2B_ABBM',
        img: ''
    },
    {
        name: "Agrobank",
        value: 'FPX_B2B_AGROBANK',
        img: ''
    },
    {
        name: "Alliance Bank",
        value: 'FPX_B2B_ABMB',
        img: ''
    },
    {
        name: "AmBank",
        value: 'FPX_B2B_AMB',
        img: ''
    },
    {
        name: "Bank Islam",
        value: 'FPX_B2B_BIMB',
        img: ''
    },
    {
        name: "BNP Paribas",
        value: 'FPX_B2B_BNP',
        img: ''
    },
    {
        name: "CIMB Bank",
        value: 'FPX_B2B_CIMB',
        img: ''
    },
    {
        name: "Citibank",
        value: 'FPX_B2B_CITIBANK',
        img: ''
    },
    {
        name: "Hong Leong",
        value: 'FPX_B2B_HLB',
        img: ''
    },
    {
        name: "HSBC",
        value: 'FPX_B2B_HSBC',
        img: ''
    },
    {
        name: "i-bizRAKYAT",
        value: 'FPX_B2B_BKRM',
        img: ''
    },
    {
        name: "Maybank2E",
        value: 'FPX_M2E',
        img: ''
    },
    {
        name: "OCBC",
        value: 'FPX_B2B_OCBC',
        img: ''
    },
    {
        name: "Public Bank",
        value: 'FPX_B2B_PBB',
        img: ''
    },
    {
        name: "Public Bank Enterprise",
        value: 'FPX_B2B_PBBE',
        img: ''
    },
    {
        name: "RHB Bank",
        value: 'FPX_B2B_RHB',
        img: ''
    },
    {
        name: "Standard Chartered Bank",
        value: 'FPX_B2B_SCB',
        img: ''
    },
    {
        name: "United Overseas Bank",
        value: 'FPX_B2B_UOB',
        img: ''
    },
    {
        name: "UOB Regional",
        value: 'FPX_B2B_UOBR',
        img: ''
    }
];